export const copyToClipboard = (str, action = null) => {
    navigator.clipboard.writeText(str);
    if (action) {
        action()
    }
}